import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as CourierModels from '../../models/couriers/courier';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class CourierService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }

  public getCourier(CourierId: number) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};
    return this.httpClient.get<CourierModels.CourierObjectModel>(`${this.environmentService.getApiURL()}/couriers/get/${CourierId}`);
}

  public setCourier(Courier: CourierModels.CourierModel) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    return this.httpClient.post<CourierModels.CourierObjectModel>(`${this.environmentService.getApiURL()}/couriers/set`, Courier, options);
  }

  public getList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<CourierModels.CourierListModel>(`${this.environmentService.getApiURL()}/couriers/list`, options);
  }

  public getDictionary() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<CourierModels.CourierListModel>(`${this.environmentService.getApiURL()}/couriers/dictionary`, options);
  }

  public deleteCourier(CourierId: number) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

  const options = { headers: httpHeaders };
    return this.httpClient.delete<CourierModels.CourierObjectModel>(`${this.environmentService.getApiURL()}/couriers/delete/${CourierId}`);
  }

  public importDPDVerification(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/couriers/import-dpd-verification`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

}
